import { render, staticRenderFns } from "./ColChartCard.vue?vue&type=template&id=54cabc4e&scoped=true"
import script from "./ColChartCard.vue?vue&type=script&lang=js"
export * from "./ColChartCard.vue?vue&type=script&lang=js"
import style0 from "./ColChartCard.vue?vue&type=style&index=0&id=54cabc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cabc4e",
  null
  
)

export default component.exports